import {
  dimensiondata_1_tetelek_group_dimension_1_column,
  dimensiondata_2_keszletek_group_row,
  ezer_kobmeter_value_1_data_no_year_summary,
  megawatt_ora_value_2_no_year_summary,
  month_row_expanded,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const gazReszletesHaviMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: { numberOfYears: 1 },
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/GazReszletesHaviMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      month_row_expanded,
      ...dimensiondata_2_keszletek_group_row,
      ...dimensiondata_1_tetelek_group_dimension_1_column,
      ezer_kobmeter_value_1_data_no_year_summary,
      megawatt_ora_value_2_no_year_summary,
      order_1,
      order_2
    ],
  },
};
